import { render, staticRenderFns } from "./UserControl.vue?vue&type=template&id=53ee43d3&"
import script from "./UserControl.vue?vue&type=script&lang=js&"
export * from "./UserControl.vue?vue&type=script&lang=js&"
import style0 from "./UserControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports